(() => {
  'use strict';

  if (window.__bcmGa4EventsV1) return;
  window.__bcmGa4EventsV1 = true;

  const script = document.currentScript;
  const measurementId = 'G-W8DSE82WHD';
  const formId = 'bcm-contact-form';
  const pendingKey = 'bcm.ga4.contact.pending.v1';
  const maxPendingAge = 10 * 60 * 1000;
  const phoneLocations = new Map([
    ['8289635503', 'foscoe'],
    ['8282642402', 'boone_mall']
  ]);
  const shortMapLocations = new Map([
    ['/cM7f2jcYd6ZSRTTn6', 'foscoe'],
    ['/q6ZK4devT1jhxJKA9', 'boone_mall']
  ]);
  const directionLocations = new Map([
    ['Blackberry Creek Mattress, 8859 NC Hwy 105 S, Boone, NC 28607', 'foscoe'],
    ['Blackberry Creek Mattress, 1180 Blowing Rock Rd, Boone, NC 28607', 'boone_mall']
  ]);

  function analyticsAllowed() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed() === true;
    } catch (_) {
      return false;
    }
  }

  function suppressed() {
    try {
      const query = new URLSearchParams(window.location.search);
      return !script || script.getAttribute('data-bcm-ga4-enabled') !== 'true' ||
        script.getAttribute('data-bcm-design-mode') !== 'false' ||
        window.top !== window.self ||
        !!(window.Shopify && (window.Shopify.designMode || window.Shopify.visualPreviewMode)) ||
        query.has('preview_theme_id') || query.has('preview_key') || query.has('bcm_ga4_qa');
    } catch (_) {
      return true;
    }
  }

  function diagnostic() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    console.info('[BCM GA4 draft diagnostic] ' + JSON.stringify({
      gtag_available: typeof window.gtag === 'function',
      consent_api_available: !!privacy && typeof privacy.analyticsProcessingAllowed === 'function',
      analytics_allowed: analyticsAllowed()
    }));
  }

  if (suppressed()) {
    const scheduleDiagnostic = () => window.setTimeout(diagnostic, 1500);
    if (document.readyState === 'complete') scheduleDiagnostic();
    else window.addEventListener('load', scheduleDiagnostic, { once: true });
    return;
  }

  function pageContext() {
    try {
      if (script.getAttribute('data-bcm-public-page') !== 'true') return null;
      const url = new URL(script.getAttribute('data-bcm-page-location'));
      if (url.origin !== 'https://blackberrycreekmattress.com' ||
          !/^(?:\/|\/(?:pages|products|collections|blogs)\/[^?#]+)$/.test(url.pathname)) return null;
      return {
        page_location: url.origin + url.pathname,
        page_path: url.pathname,
        page_referrer: '',
        page_title: 'Blackberry Creek Mattress'
      };
    } catch (_) {
      return null;
    }
  }

  if (!pageContext()) return;

  function send(eventName, parameters) {
    const context = pageContext();
    if (!context || suppressed() || !analyticsAllowed() || typeof window.gtag !== 'function') return;
    try {
      window.gtag('event', eventName, { send_to: measurementId, ...context, ...parameters });
      return true;
    } catch (_) {}
  }

  function locationForLink(href) {
    if (/^tel:/i.test(href)) {
      const number = href.slice(4).replace(/[\s().-]/g, '');
      const match = number.match(/^(?:\+?1)?([2-9]\d{9})$/);
      const location = match && phoneLocations.get(match[1]);
      return location ? ['store_call_click', location, 'tel:+1' + match[1]] : null;
    }
    try {
      const url = new URL(href, window.location.origin);
      if (url.protocol !== 'https:' || url.username || url.password || url.port) return null;
      if (url.hostname === 'maps.app.goo.gl') {
        const location = shortMapLocations.get(url.pathname.replace(/\/$/, ''));
        return location ? ['store_directions_click', location, 'https://maps.app.goo.gl/' + (location === 'foscoe' ? 'cM7f2jcYd6ZSRTTn6' : 'q6ZK4devT1jhxJKA9')] : null;
      }
      if (url.hostname === 'www.google.com' && url.pathname === '/maps/dir/' &&
          url.searchParams.get('api') === '1' && url.searchParams.getAll('destination').length === 1) {
        const location = directionLocations.get(url.searchParams.get('destination'));
        return location ? ['store_directions_click', location, 'https://maps.app.goo.gl/' + (location === 'foscoe' ? 'cM7f2jcYd6ZSRTTn6' : 'q6ZK4devT1jhxJKA9')] : null;
      }
    } catch (_) {}
    return null;
  }

  const locationPaths = new Map([
    ['/pages/boone-mall-location', 'boone_mall'],
    ['/pages/foscoe-location', 'foscoe']
  ]);
  const visitPaths = new Set(['/pages/helix-mattresses', '/pages/tempurpedic-mattresses']);

  function ctaPosition(link) {
    if (link.closest('#mobile-menu')) return 'mobile_navigation';
    if (link.closest('.bcm-util-bar, header')) return 'header';
    if (link.closest('#footer, footer')) return 'footer';
    const path = pageContext().page_path;
    if (locationPaths.has(path) || path === '/pages/store-locations') return 'location_page';
    if (path.startsWith('/products/')) return 'product_page';
    if (visitPaths.has(path) || path.startsWith('/collections/')) return 'brand_page';
    return path === '/' ? 'homepage' : 'page_content';
  }

  function visitForLink(link, href, position) {
    // Only known public destinations; no arbitrary text, queries or hashes enter analytics.
    try {
      const context = pageContext();
      const url = new URL(href, context.page_location);
      if (url.origin !== window.location.origin || url.username || url.password) return null;
      const path = url.pathname.replace(/\/$/, '') || '/';
      const location = locationPaths.get(path);
      if (location) return { store_location: location, link_url: url.origin + path };
      if (path === '/pages/store-locations' && !['header', 'mobile_navigation', 'footer'].includes(position)) {
        return { link_url: url.origin + path };
      }
      if (visitPaths.has(context.page_path) && path === context.page_path && url.hash === '#visit') {
        return { link_url: context.page_location + '#visit' };
      }
    } catch (_) {}
    return null;
  }

  document.addEventListener('click', (event) => {
    if (suppressed() || !event.isTrusted || event.defaultPrevented || event.button !== 0 || !analyticsAllowed()) return;
    const target = event.target;
    const link = target && typeof target.closest === 'function' ? target.closest('a[href]') : null;
    if (!link) return;
    const href = link.getAttribute('href') || '';
    const result = locationForLink(href);
    const position = ctaPosition(link);
    if (result) {
      send(result[0], { store_location: result[1], cta_position: position, link_url: result[2] });
      return;
    }
    const visit = visitForLink(link, href, position);
    if (visit) send('plan_visit_click', { ...visit, cta_position: position });
  });

  let locationViewSent = false;
  function trackLocationView() {
    if (locationViewSent || document.visibilityState === 'hidden') return;
    const context = pageContext();
    const location = context && locationPaths.get(context.page_path);
    if (location) locationViewSent = send('store_location_view', {
      store_location: location, cta_position: 'location_page'
    }) === true;
  }
  // One view per document, including consent granted while this page is still open.
  window.addEventListener('load', trackLocationView, { once: true });
  document.addEventListener('visitorConsentCollected', trackLocationView);
  document.addEventListener('visibilitychange', trackLocationView);
  if (document.readyState === 'complete') trackLocationView();

  document.addEventListener('submit', (event) => {
    if (suppressed() || !event.isTrusted || !analyticsAllowed()) return;
    try {
      window.sessionStorage.removeItem(pendingKey);
      const form = event.target;
      if (event.defaultPrevented || !form || form.id !== formId || form.tagName !== 'FORM' ||
          form.getAttribute('data-bcm-contact-form') !== 'true' ||
          form.method.toLowerCase() !== 'post' || typeof window.gtag !== 'function') return;
      const action = new URL(form.action, window.location.origin);
      if (action.origin !== window.location.origin || !/\/contact$/.test(action.pathname)) return;
      const marker = { token: window.crypto.randomUUID(), createdAt: Date.now() };
      window.sessionStorage.setItem(pendingKey, JSON.stringify(marker));
    } catch (_) {}
  });

  function processContactResult() {
    // A confirmed result may load before consent or gtag is ready. Keep the short-lived marker for a later check.
    if (suppressed() || !analyticsAllowed() || typeof window.gtag !== 'function') return;
    try {
      const stored = window.sessionStorage.getItem(pendingKey);
      if (!stored) return;
      let marker;
      try { marker = JSON.parse(stored); } catch (_) { window.sessionStorage.removeItem(pendingKey); return; }
      const age = marker && Date.now() - marker.createdAt;
      const form = document.getElementById(formId);
      const navigation = window.performance.getEntriesByType('navigation')[0];
      if (!marker || typeof marker.token !== 'string' ||
          !/^[a-f\d]{8}(?:-[a-f\d]{4}){3}-[a-f\d]{12}$/i.test(marker.token) ||
          !Number.isFinite(marker.createdAt) || age < 0 || age > maxPendingAge ||
          !navigation || navigation.type !== 'navigate' ||
          window.location.hash !== '#' + formId || !form ||
          form.getAttribute('data-bcm-contact-form') !== 'true' ||
          !form.querySelector('[data-bcm-contact-success="true"]') ||
          form.querySelector('[data-bcm-contact-error="true"]')) {
        window.sessionStorage.removeItem(pendingKey);
        return;
      }
      if (send('generate_lead', { form_id: formId }) === true) {
        window.sessionStorage.removeItem(pendingKey);
      }
    } catch (_) {}
  }

  document.addEventListener('visitorConsentCollected', processContactResult);
  window.addEventListener('load', processContactResult, { once: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processContactResult, { once: true });
  } else {
    processContactResult();
  }
})();

